import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "live-house-page"
};
const _hoisted_2 = {
  class: "wrap white-bg"
};
const _hoisted_3 = {
  class: "flex-row-box"
};
const _hoisted_4 = {
  class: "tab-wrap"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "search-wrap"
};
const _hoisted_7 = {
  key: 0,
  class: "live-house-list-box"
};
const _hoisted_8 = {
  "infinite-scroll-delay": 1000,
  "infinite-scroll-distance": 200,
  "infinite-scroll-immediate": false,
  class: "list-wrap"
};
const _hoisted_9 = {
  class: "list-item-header"
};
const _hoisted_10 = {
  class: "list-item-header-left"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "desc"
};
const _hoisted_13 = {
  class: "list-item-header-right"
};
const _hoisted_14 = {
  class: "list-item-content"
};
const _hoisted_15 = {
  key: 0,
  class: "start-broadcast"
};
const _hoisted_16 = {
  key: 0,
  class: "no-more-data"
};
const _hoisted_17 = {
  key: 1
};
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { closeSession } from '@/request/live';
import { deleteLiveRoom, getAppMyLiveRoomPage, getLiveRoomStatSession } from '@/request/program';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import LiveTypeDialog from './components/LiveTypeDialog.vue';
import livestreamingCredit from '@/layout/components/appMain/livestreamingCredit.vue';
import { PollingTimer } from '@/utils/pollingTimer';
//ref

export default {
  __name: 'livehouse',
  setup(__props) {
    const liveTypeDialog = ref(null);
    const router = useRouter();
    const tabs = ref([{
      label: '我的直播间',
      value: 'house'
    }
    /* {
      label: '直播数据',
      value: 'data',
    }, */]); // 直播间列表
    const loading = ref(false); // 页面加载中
    const activeTab = ref('house'); // 当前选中的tab
    const lists = ref([]); // 直播间列表
    const listPageIndex = ref(1); // 直播间列表页码
    const listPageSize = ref(17); // 直播间列表每页数量
    const listNoMore = ref(false); // 直播间列表是否没有更多数据
    const dialogVisible = ref(false); // 弹窗是否显示
    const currentProgramm = ref({}); // 当前节目
    const previewSrc = ref(''); // 预览视频
    const keywords = ref(''); // 搜索关键词
    const tableData = ref([]); // 直播间数据

    onMounted(() => {
      updateData();
    });
    // 切换tab
    const toggleTab = tab => {
      activeTab.value = tab.value;
    };
    let openNewTab = item => {
      window.open(`#/live/${item.id}/live-house/webrtc`, '_blank');
    };
    let closeLive = async item => {
      try {
        await closeSession({
          roomId: item.id
        });
        ElMessage.success('操作成功');
      } catch (error) {
        console.error('Error closing live session:', error);
        // closeDialogAndStopPolling();
      }
    };
    const openLiveTypeDialog = async item => {
      try {
        const roomStateRes = await getLiveRoomStatSession(item.id);
        const {
          code: roomStateCode,
          data: roomStateData
        } = roomStateRes.data;
        console.log('roomStateCode', roomStateCode);
        if (roomStateCode == 200) {
          // 如果是待关闭状态 提前关闭一下
          // if (!roomStateData.ROOM_STATE || roomStateData.ROOM_STATE === 6) {
          //   await closeSession({ roomId: item.id });
          // }
          if (roomStateData.ROOM_STATE === 4) {
            let {
              protocol = ''
            } = roomStateData.START_PARAMS;
            let {
              roomId = ''
            } = roomStateData.CURRENT_TEXT_STORAGE;
            if (protocol === 'rtmp') {
              window.open(`#/live/${roomId}/live-house/rtmp`, '_blank');
            }
            if (protocol === 'webrtc') {
              window.open(`#/live/${roomId}/live-house/webrtc`, '_blank');
            }
          } else {
            liveTypeDialog.value.openDialog(item);
          }
        }
      } catch (err) {
        console.error(err);
        await closeSession({
          roomId: item.id
        });
      }
    };

    // 跳转到编辑直播间页面
    const gotoEdit = (type, {
      id,
      screen
    }) => {
      router.push({
        path: `/interactiveman/new-live/${type}`,
        query: {
          id
        }
      });
    };
    const load = async () => {
      console.log('load');
      if (listNoMore.value) {
        return;
      }
      if (!listNoMore.value) {
        loading.value = true;
      }
      ++listPageIndex.value;
      const data = await getData();
      // 如果实际请求的数量少于当前数量，说明没有更多数据了
      if (data.list.length < listPageSize.value) {
        listNoMore.value = true;
      }
      lists.value = [...lists.value, ...data.list];
      loading.value = false;
    };

    // 跳转到创建直播间页面
    const gotoAdd = type => {
      router.push({
        path: `/interactiveman/new-live/${type}`
      });
    };

    // 预览节目
    const preview = val => {
      var _val$list$;
      dialogVisible.value = true;
      currentProgramm.value = val;
      previewSrc.value = (_val$list$ = val.list[0]) === null || _val$list$ === void 0 ? void 0 : _val$list$.src;
    };
    const handleSearch = async () => {
      console.log('handleSearch');
      const data = await getData();
      lists.value = data.list || [];
    };

    // 获取直播间数据

    onUnmounted(() => {
      // timer.cancel()
    });
    const updateData = async () => {
      try {
        const data = await getData();
        lists.value = data.list || [];
        return false;
      } catch (error) {
        return true;
      }
    };

    // 获取直播间数据
    const getData = async () => {
      try {
        loading.value = true;
        const res = await getAppMyLiveRoomPage({
          pageIndex: listPageIndex.value,
          pageSize: listPageSize.value,
          keywords: keywords.value
        });
        const {
          data
        } = res.data;
        loading.value = false;
        console.log('da？？？t/a', data);
        return data;
      } catch (err) {
        ElMessage.error('获取直播间数据失败');
      } finally {
        loading.value = false;
      }
    };
    // let timer = new PollingTimer(updateData, 5 * 1000)
    // timer.start()
    // 删除直播间
    const onDelete = id => {
      ElMessageBox.confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteLiveRoom(id);
        const {
          code
        } = res.data;
        if (code == 200) {
          ElMessage.success('删除成功');
          const data = await getData();
          lists.value = data.list || [];
        }
      });
    };

    // 直播抵扣
    let livestreaming = ref(false);
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_CirclePlus = _resolveComponent("CirclePlus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, item => {
        return _openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["tab-item", activeTab.value == item.value && 'active']),
          key: item.value,
          onClick: $event => toggleTab(item)
        }, _toDisplayString(item.label), 11, _hoisted_5);
      }), 128))]), _createElementVNode("div", _hoisted_6, [false ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        modelValue: _ctx.input2,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.input2 = $event),
        style: {
          "max-width": "600px"
        },
        placeholder: "输入关键词进行搜索"
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          class: "search-button",
          onClick: handleSearch,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("i", {
            class: "ri-search-line"
          }, null, -1)])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)])]), activeTab.value == 'house' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          style: {
            "padding": "5px"
          },
          xs: 24,
          sm: 12,
          md: 8,
          lg: 4,
          xl: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            shadow: "never",
            class: "list-item-add-box"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "list-item-add flex-column-box radius-middle",
              onClick: _cache[1] || (_cache[1] = $event => gotoAdd(1))
            }, [_createVNode(_component_el_icon, {
              size: "1.8vw"
            }, {
              default: _withCtx(() => [_createVNode(_component_CirclePlus)]),
              _: 1
            }), _cache[5] || (_cache[5] = _createTextVNode(" 创建交互直播 "))])]),
            _: 1
          })]),
          _: 1
        }), lists.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(lists.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            xs: 24,
            sm: 12,
            md: 8,
            lg: 4,
            xl: 4,
            class: "list-item-wrap",
            key: item.id
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, {
              shadow: "never",
              class: "list-item-box"
            }, {
              header: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(item.industryType), 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                    onClick: $event => gotoEdit(1, item)
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("i", {
                      class: "ri-draft-line"
                    }, null, -1), _createTextVNode("编辑")])),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                    onClick: $event => onDelete(item.id)
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("i", {
                      class: "ri-delete-bin-6-line"
                    }, null, -1), _createTextVNode("删除")])),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("i", {
                  class: "ri-list-unordered el-dropdown-link"
                }, null, -1))]),
                _: 2
              }, 1024)])])]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_image, {
                src: item.showUrl || require('@/assets/images/video_play.png'),
                style: {
                  "width": "100%",
                  "height": "100%"
                },
                onClick: $event => openLiveTypeDialog(item)
              }, null, 8, ["src", "onClick"]), false ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_button, {
                class: "start-btn",
                onClick: $event => openLiveTypeDialog(item)
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("去开播")])),
                _: 2
              }, 1032, ["onClick"])])) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128)) : _createCommentVNode("", true)]),
        _: 1
      }), listNoMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 没有更多数据了.... ")) : _createCommentVNode("", true)])), [[_directive_infinite_scroll, load]])])) : _createCommentVNode("", true), activeTab.value == 'data' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%"
        },
        "header-row-class-name": "table-header",
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "d",
          label: "序号",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "直播ID",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "行业类型"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "直播间名称"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "观看人数"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "收藏人数"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "用户问题"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "开播时长"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "开播时间"
        })]),
        _: 1
      }, 8, ["data"])])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]), _createVNode(LiveTypeDialog, {
        ref_key: "liveTypeDialog",
        ref: liveTypeDialog
      }, null, 512), _createVNode(_component_el_dialog, {
        modelValue: _unref(livestreaming),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(livestreaming) ? livestreaming.value = $event : livestreaming = $event),
        width: "30%"
      }, {
        default: _withCtx(() => [_unref(livestreaming) ? (_openBlock(), _createBlock(livestreamingCredit, {
          key: 0,
          onCloseDialog: _cache[2] || (_cache[2] = $event => _isRef(livestreaming) ? livestreaming.value = false : livestreaming = false)
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};